import { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

import { SwapEffect, SwapOffProps, SwapOnProps, SwapProps } from './types';

const effectClasses: Record<SwapEffect, string> = {
  rotate: 'swap-rotate',
  flip: 'swap-flip',
};

const SwapBase = forwardRef<HTMLSpanElement, SwapProps>(
  ({ className, active = false, effect, children, ...props }, ref) => {
    const classes = twMerge(
      'swap',
      effect && effectClasses[effect],
      active && 'swap-active',
      className,
    );

    return (
      <span ref={ref} className={classes} {...props}>
        {children}
      </span>
    );
  },
);

const On = forwardRef<HTMLSpanElement, SwapOnProps>(
  ({ className, children, ...props }, ref) => (
    <span ref={ref} className={twMerge('swap-on', className)} {...props}>
      {children}
    </span>
  ),
);

const Off = forwardRef<HTMLSpanElement, SwapOffProps>(
  ({ className, children, ...props }, ref) => (
    <span ref={ref} className={twMerge('swap-off', className)} {...props}>
      {children}
    </span>
  ),
);

SwapBase.displayName = 'Swap';
On.displayName = 'Swap.On';
Off.displayName = 'Swap.Off';

export const Swap = Object.assign(SwapBase, {
  On,
  Off,
});
